import { SVGProps } from 'react'

export const CheckMarkCircleSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="currentColor" {...props}>
    <rect width={20} height={20} y={0.809} fill="currentColor" rx={10} />
    <path
      stroke="#fff"
      strokeWidth="1.667"
      d="m5.832 10.808 2.5 2.5 5.833-5.833"
    />
  </svg>
)
